import React, { useEffect, useState } from 'react';
// import { deleteSingleArtisanPublicInquiryAction, getPendingPublicInquiriesAction } from "../../../../modules/artisanModeration/publicInquiry/Actions";
import {
  deleteArtisanPublicInquiryAction,
  getArtisanPublicInquiryAction,
  getArtisnPublicInquiriesAction,
  addArtisanPublicInquiryAction,
  editArtisanPublicInquiryAction
} from '../../../../modules/inquiries/artisans/public/Actions';
// import {
//   pendingArtisansPublicInquiryAsListSelector,
//   pendingArtisansPublicInquiryCountSelector,
//   pendingArtisansPublicInquiryIsLoadingSelector,
// } from "../../../../modules/artisanModeration/publicInquiry/Selectors";

import {
  PublicArtisanListSelector,
  artisanPublicInquiriesSelector,
  artisanPublicInquiriesIsLoadingSelector,
  inquiryCountSelector
} from '../../../../modules/inquiries/artisans/public/Selectors';

import { connect } from 'react-redux';

import List from '../../../../components/Lists/List';
import ListItem from '../../../../components/Lists/ListItem';
import InfiniteScroll from 'react-infinite-scroll-component';
import { customerDataSelector } from '../../../../modules/auth/Selectors';
import getLangData from '../../../../utils/getLangData';

const PendingArtisansList = props => {
  const {
    publicInquiries = [],
    publicInquiriesIsLoading,
    getPublicInquiries,
    publicInquiriesCount = 0,
    deletePublicArtisanInquiry,
    customerData
  } = props;

  const [size, setSize] = useState(10);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const customerId = customerData._id;
  useEffect(() => {
    getPublicInquiries({
      filterCustomerID: customerId,
      customerId: customerId,
      url: 'public-artisan-inquiry/search-public-inquiries-for-customer/',
      filterBy: [{ rejected: false }]
    });
  }, []);

  const fetchMore = () => {
    // set hasMore to false if the current items are >= the all items in database !
    if (publicInquiries.length >= publicInquiriesCount) {
      setHasMore(false);
      return false;
    }

    // otherwise get the data from the database
    getPublicInquiries({
      size,
      offset: publicInquiries.length,
      filterCustomerID: customerId,
      customerId: customerId,
      url: 'public-artisan-inquiry/search-public-inquiries-for-customer/',
      filterBy: [{ rejected: false }]
    });
  };

  const dataLength =
    publicInquiries.length <= publicInquiriesCount
      ? publicInquiries.length
      : publicInquiriesCount;

  return (
    <InfiniteScroll
      dataLength={dataLength}
      hasMore={hasMore}
      next={fetchMore}
      style={{ overflow: 'hidden' }}
    >
      <div className='table row block--container my-5'>
        <List
          isLoading={publicInquiriesIsLoading}
          // header={{ items: ['Title'], actions: ['View', 'Delete'] }}
          header={{ items: [getLangData().fields.name], actions: ['View'] }}
          items={publicInquiries}
        >
          <table className='table'>
            <tbody>
              {publicInquiries.map(
                ({
                  moderationId,
                  message,
                  _id,
                  moderated,
                  proposals,
                  title
                }) => {
                  return (
                    <ListItem
                      proposals={proposals}
                      type='multi'
                      name={title}
                      data={[title]}
                      key={_id}
                      viewLink={`/customer-public-inquiry-artisan/${_id}`}
                      // onDelete={() => deletePublicArtisanInquiry(_id)}
                      moderated={moderated}
                    />
                  );
                }
              )}
            </tbody>
          </table>
        </List>
      </div>
    </InfiniteScroll>
    // <List
    //   isLoading={publicInquiriesIsLoading}
    //   header={{ items: ["Message"], actions: ["Edit", "Delete"] }}
    //   items={publicInquiries}
    // >
    //   {/* <InfiniteScroll
    //     dataLength={dataLength}
    //     hasMore={hasMore}
    //     next={fetchMore}
    //   > */}
    //     {publicInquiries.map(({ businessName, message , _id,  }) => {
    //       return (
    //         <ListItem
    //           //  type='multi'
    //            name={message}
    //           // data={[message]}
    //           key={_id}
    //           viewLink={`/customer-public-inquiry-artisan/${_id}`}
    //           onDelete={() => deletePublicArtisanInquiry(_id) }
    //       >{console.log(publicInquiries)}</ListItem>
    //       );
    //     })}
    //   {/* </InfiniteScroll> */}
    // </List>
  );
};

const mapStateToProps = state => ({
  publicInquiries: PublicArtisanListSelector(state),
  publicInquiriesIsLoading: artisanPublicInquiriesIsLoadingSelector(state),
  customerData: customerDataSelector(state),
  publicInquiriesCount: inquiryCountSelector(state)
});

export default connect(mapStateToProps, {
  getPublicInquiries: getArtisnPublicInquiriesAction,
  deletePublicArtisanInquiry: deleteArtisanPublicInquiryAction
})(PendingArtisansList);
